import { PatientProviders } from './app/PatientProviders';
import { PatientRouter } from './app/PatientRouter';

export default function App() {
  return (
    <PatientProviders>
      <PatientRouter />
    </PatientProviders>
  );
}
